export default {
  0: {
    code: 'Sin Cumplimentar',
    bgColor: '#e8e8d5',
    iconColor: '#2d5472',
    icon: 'file',
    id: 0,
  },
  1: {
    code: 'Cumplido',
    bgColor: '#48b363',
    iconColor: '#ffffff',
    icon: 'check',
    id: 1,

  },
  2: {
    code: 'En Trámite',
    bgColor: '#e7a163',
    iconColor: '#ffffff',
    icon: 'settings-5',
    id: 2,
  },
  3: {
    code: 'Incumplido',
    bgColor: '#e04040',
    iconColor: '#ffffff',
    icon: 'close',
    id: 3,
  },
  4: {
    code: 'No aplica',
    bgColor: '#878787',
    iconColor: '#ffffff',
    icon: 'server',
    id: 4,
  },
  5: {
    code: 'Obsoleta',
    bgColor: '#333333',
    iconColor: '#ffffff',
    icon: 'spam',
    id: 5,
  },
};
